const MENSAJE_EMPRESA_INVALIDA = "No hay una empresa valida seleccionada.";

export function normalizarEmpresaId(value) {
  const empresaId = Number(value);
  if (!Number.isSafeInteger(empresaId) || empresaId <= 0) {
    throw new Error(MENSAJE_EMPRESA_INVALIDA);
  }
  return empresaId;
}

export function obtenerEmpresaId() {
  return normalizarEmpresaId(obtenerSesion()?.EmpresaId ?? localStorage.getItem("EmpresaId"));
}

export function conEmpresa(empresaId, payload = {}) {
  return { ...payload, EmpresaId: normalizarEmpresaId(obtenerSesion()?.EmpresaId ?? empresaId) };
}

export function normalizarSesionEmpresa(respuesta = {}) {
  return {
    ...respuesta,
    EmpresaId: normalizarEmpresaId(respuesta.EmpresaId ?? respuesta.Empresa_Id),
  };
}

export function esErrorEmpresaInvalida(status, mensaje) {
  return Number(status) === 400
    && /EmpresaId/i.test(String(mensaje || ""))
    && /(mayor|positiv|cero|valid|requerid|obligatori)/i.test(String(mensaje || ""));
}

export { MENSAJE_EMPRESA_INVALIDA };
import { obtenerSesion } from "./sesionSeguridad";
